// extracted by mini-css-extract-plugin
module.exports = {"player":"player__C1OiX"};